import { createLogger, TrackingService } from "@chesspresso/common";
import { parsePgn } from "chessops/pgn";

const logger = createLogger("classify-util");

export type OpeningMatch = {
    eco: string;
    name: string;
    ply: number;
};

const buildMoveSequence = (moves: string[]): string => {
    let result = "";
    for (let i = 0; i < moves.length; i++) {
        if (i % 2 === 0) {
            if (result.length > 0) {
                result += " ";
            }
            result += `${Math.floor(i / 2) + 1}.`;
        }
        result += ` ${moves[i]}`;
    }
    return result.trim();
};

const fromPGN = (
    pgn: string,
    maxPly = 20,
    openingIndex: Map<string, OpeningMatch>
): OpeningMatch | undefined => {
    const moves: string[] = [];
    try {
        const [game] = parsePgn(pgn);

        if (!game) {
            return undefined;
        }

        for (const node of game.moves.mainline()) {
            moves.push(node.san);
        }
    } catch (error) {
        logger.error(
            { error, pgn },
            "Failed to load pgn for opening classification"
        );
        TrackingService.captureError(error);
        return undefined;
    }

    if (!Array.isArray(moves) || moves.length === 0) {
        logger.warn(
            { pgn },
            "No moves found in PGN for opening classification"
        );
        return undefined;
    }

    const limit = Math.min(moves.length, maxPly);
    for (let i = limit; i >= 1; i--) {
        const moveSeq = buildMoveSequence(moves.slice(0, i));
        const hit = openingIndex.get(moveSeq);

        if (hit) {
            return { ...hit, ply: i };
        }
    }
    return undefined;
};

export const ClassifyOpeningUtil = { fromPGN };
